/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  // Mail,
  Checkbox as CheckboxIcon,
  Signal,
  Linkedin,
  InfoCircle,
  Braces2,
  Whatsapp,
  // Copy,
  // Check,
  // ChevronDown,
  Calendar,
  CircleCheck,
} from '@saleshandy/icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import insertTextAtCursor from 'insert-text-at-cursor';
import classnames from 'classnames';
import { Button } from '@saleshandy/design-system';
import { v4 as uuidv4 } from 'uuid';
import Editor from '../../../../../../../../../../shared/editor/editor';
import {
  getInitialSubType,
  getStepContentSectionLabel,
  getSubTypeSectionLabel,
  isSubTypeSectionVisible,
  getLinkedInType,
  getSequenceTypeTooltipText,
  isFormValid,
  contentMaxLength,
  subjectInputMaxLength,
  isSubmitDisabled,
  getErrorString,
  getMinLength,
  getPlaceHolderText,
  getIsTaskNoteContent,
  getTaskNoteModalTitle,
  getTaskNoteModalMaxLength,
  getCallInType,
  PurposeOfCall,
  getWhatsappInType,
  WhatsAppTaskType,
  LinkedInTaskType,
  WHATSAPP_MAX_LIMIT,
  getStepType,
  getEditorHeight,
} from '../../../../../../../../../sequence/shared/modals/create-step-modal/utils/helper';
import StepTaskType from '../../../../../../../../../sequence/shared/modals/create-step-modal/components/step-task-type';
import TaskNote from '../../../../../../../../../sequence/shared/modals/create-step-modal/components/task-note';
import TaskPriority from '../../../../../../../../../sequence/shared/modals/create-step-modal/components/task-priority';
import {
  SequenceStepAction,
  SequenceStepExecutionDay,
  SequenceStepPriorityValue,
  SequenceStepType,
  StepType,
} from '../../../../../../../../../sequence/enums';
import { TaskAction } from '../../../../../../../../../tasks/utils/enums';
import TaskAssignee from '../../../../../../../../../sequence/shared/modals/create-step-modal/components/task-assignee';
import { validateRelativeDays } from '../../../../../../../../../sequence/shared/modals/add-step-modal/validator';
import { stepBgColor } from '../../../../../../../../../sequence/helpers/step-types';
import { accessibleOnClick } from '../../../../../../../../../../shared/utils/accessible-on-click';
import OverlayMergeTags from '../../../../../../../../../../shared/components/overlay-merge-tags';
import {
  OverlayTooltip,
  Placement,
} from '../../../../../../../../../../shared/design-system/components/overlay';
import { prepareMergeTagOptions } from '../../../../../../../../../sequence/shared/modals/email-modal/helpers';
import Input from '../../../../../../../../../../shared/design-system/components/input';
import SingleEditorInput from '../../../../../../../../../sequence/shared/modals/email-modal/components/single-editor-input';
import {
  isCallTask,
  isWhatsappTask,
  getCallOutcomeOptions,
  getCallTaskDesc,
  getTaskActionTitle,
  getConfirmationModalClass,
} from '../../../../../../../../../tasks/components/tasks-content/utils/helper';
import {
  isValidHTML,
  nl2br,
  br2nl,
} from '../../../../../../../../../sequence/shared/modals/email-modal/components/sidebar/tabs/utils/get-merge-tag-mapping-with-values';
import {
  stripChipTagsFromHtml,
  insertChipForMergeTag,
  setCaretAfterChip,
} from '../../../../../../../../../../shared/editor/helpers';
import { convertHtmlToText } from '../../../../../../../../../sequence/shared/modals/email-modal/components/sidebar/tabs/utils/get-parsed-content-for-text-only-email';
import TaskNoteModal from '../../../../../../../../../sequence/shared/modals/create-step-modal/components/task-note/components/task-note-modal';
import {
  StepFormDirty,
  StepFormError,
} from '../../../../../../../../../sequence/shared/modals/create-step-modal/type';
import { validate } from '../../../../../../../../../sequence/shared/modals/create-step-modal/utils/validator';
import Checkbox from '../../../../../../../../../../shared/design-system/ui/checkbox';
import { getFieldsRequest } from '../../../../../../../../../sequence/shared/modals/email-modal/test-email/extra-actions';
import ConfirmationModalV3 from '../../../../../../../../../../shared/design-system/components/atoms/confirmation-modal/confirmation-modal-v3';
import Select from '../../../../../../../../../../shared/design-system/components/select';
import { getIsDemoAccount } from '../../../../../../../../../../shared/utils/user-details';
import { combineDateWithCurrentTime } from '../../utils/helper';
import Icon from '../../../../../../../../../../shared/design-system/components/atoms/icon';

const stepTypeClasses = {
  // [StepType.Email]: { active: 'gray-txt-1', inactive: 'blue-txt-24' },
  [StepType.LinkedIn]: { active: 'gray-txt-1', inactive: 'blue-txt-24' },
  [StepType.Call]: { active: 'gray-txt-1', inactive: 'purple-txt-16' },
  [StepType.WhatsApp]: { active: 'gray-txt-1', inactive: 'green-txt-23' },
  [StepType.Task]: { active: 'gray-txt-1', inactive: 'orange-txt-21' },
};

const stepTypeIcons = {
  // [StepType.Email]: Mail,
  [StepType.LinkedIn]: Linkedin,
  [StepType.Call]: Signal,
  [StepType.WhatsApp]: Whatsapp,
  [StepType.Task]: CheckboxIcon,
};

const getChannels = (stepType) =>
  Object.keys(stepTypeIcons).map((key) => {
    const IconComponent = stepTypeIcons[key];
    return {
      key: StepType[key],
      icon: (
        <IconComponent
          width={20}
          height={20}
          className={
            stepType === key
              ? stepTypeClasses[key].active
              : stepTypeClasses[key].inactive
          }
        />
      ),
    };
  });

// Get default sub-type for a given StepType
const getDefaultSubTypeForStepType = (stepType: StepType): string => {
  if (stepType === StepType.WhatsApp) {
    return WhatsAppTaskType.Message;
  }
  if (stepType === StepType.LinkedIn) {
    return LinkedInTaskType.ConnectionRequest;
  }
  if (stepType === StepType.Call) {
    return PurposeOfCall.Introduction;
  }
  // For Task type, return empty string as it doesn't have sub-types
  return '';
};

interface AddTaskFormProps {
  onCancel?: () => void;
  onSubmit?: (data: any) => void;
  fields?: any[];
  taskAssigneeList?: any[];
  userId?: number;
  defaultStepType?: StepType;
  initialStepType?: SequenceStepType;
  isSubmitLoading?: boolean;
  selectedProspectId?: number;
  sendUploadAttachmentRequest?: (payload: any) => void;
  uploadAttachmentRequestStatus?: any;
  uploadAttachmentRequestError?: any;
  uploadedAttachment?: any;
  sendDeleteAttachmentRequest?: (payload: any) => void;
  deleteAttachmentRequestStatus?: any;
  deleteAttachmentRequestError?: any;
  deletedAttachmentId?: number;
  sendImageUploadRequest?: (payload: any) => void;
  resetUploadAttachmentRequest?: () => void;
  resetDeleteAttachmentRequest?: () => void;
  setShowGlobalRestrictionModal?: (type: SequenceStepType) => void;
}

const AddTaskForm: React.FC<AddTaskFormProps> = ({
  onCancel,
  onSubmit,
  fields: fieldsProp = [],
  taskAssigneeList,
  userId,
  defaultStepType = StepType.LinkedIn,
  initialStepType = SequenceStepType.LinkedInConnectionRequest,
  isSubmitLoading = false,
  selectedProspectId,
  sendUploadAttachmentRequest,
  uploadAttachmentRequestStatus,
  uploadAttachmentRequestError,
  uploadedAttachment,
  sendDeleteAttachmentRequest,
  deleteAttachmentRequestStatus,
  deleteAttachmentRequestError,
  deletedAttachmentId,
  sendImageUploadRequest,
  resetUploadAttachmentRequest,
  resetDeleteAttachmentRequest,
  setShowGlobalRestrictionModal,
}) => {
  const dispatch = useDispatch();
  // Get fields from Redux store if not provided as prop
  const fieldsFromStore = useSelector(
    (state: any) => state.emailModal?.fields || [],
  );
  // Use fields from prop if provided and not empty, otherwise use from store
  const fields = useMemo(
    () => (fieldsProp && fieldsProp.length > 0 ? fieldsProp : fieldsFromStore),
    [fieldsProp, fieldsFromStore],
  );

  const contentRef = useRef<any>();
  const inMailRef = useRef<HTMLInputElement>(null);
  const inMailEditorRef = useRef<any>(null);
  const editorRef = useRef<any>(null);
  const mergeTagOptions = useMemo(() => {
    if (!fields || fields.length === 0) {
      return [];
    }
    const options = prepareMergeTagOptions(fields);
    return options || [];
  }, [fields]);

  //* State */
  const [absoluteDays, setAbsoluteDays] = useState<number>(1);
  const [selectedStepType, setSelectedStepType] = useState<SequenceStepType>(
    initialStepType,
  );
  const [selectedStepSubType, setSelectedStepSubType] = useState<string>(
    getInitialSubType(initialStepType),
  );
  const [stepType, setStepType] = useState<StepType>(
    initialStepType ? getStepType(initialStepType) : defaultStepType,
  );
  const [stepContentHTML, setStepContentHTML] = useState('');
  const [taskNote, setTaskNote] = useState<string>('');
  // WhatsApp-specific content state for Message type
  const [whatsappMessageContent, setWhatsappMessageContent] = useState<string>(
    '',
  );
  // WhatsApp-specific content state for Voice types (Voice Message and Voice Call)
  const [whatsappVoiceContent, setWhatsappVoiceContent] = useState<string>('');
  const [
    selectedPriority,
    setSelectedPriority,
  ] = useState<SequenceStepPriorityValue>(SequenceStepPriorityValue.Normal);
  const [selectedAssignee, setSelectedAssignee] = useState(userId);
  const [inMailValue, setInMailValue] = useState<string>('');
  const [errors, setErrors] = useState<StepFormError>({
    buttonName: false,
    buttonLink: false,
    inMail: false,
    content: false,
  });
  const [isDirty, setDirty] = useState<StepFormDirty>({
    buttonName: false,
    buttonLink: false,
    inMail: false,
    content: false,
    inMailSubject: false,
    customTitle: false,
  });
  const [isAddTaskModalVisible, setAddTaskModalVisible] = useState<boolean>(
    false,
  );

  // Add attachment state for Editor component
  const [attachments, setAttachments] = useState([]);
  const [attachmentsMeta, setAttachmentsMeta] = useState([]);
  const [uniqueId] = useState(Date.now());
  const [dueDate, setDueDate] = useState<Date | null>(null);

  // State to track WhatsApp editor character limit exceeded
  const [
    isWhatsappCharacterLimitExceeded,
    setIsWhatsappCharacterLimitExceeded,
  ] = useState(false);

  // State for "Mark as Completed" checkbox
  const [isCompleted, setIsCompleted] = useState<boolean>(false);

  // State for call outcome modal
  const [
    isCallOutcomeModalVisible,
    setIsCallOutcomeModalVisible,
  ] = useState<boolean>(false);
  const [callOutcome, setCallOutcome] = useState<{
    key: string;
    label: string;
  } | null>(null);

  //* State End */

  //* Functions */
  const showModal = () => setAddTaskModalVisible(true);
  const hideModal = () => setAddTaskModalVisible(false);

  // Add attachment handlers for Editor component
  const handleAttachmentStatusChange = (attachment) => {
    setAttachments((prev) =>
      prev.map((att) =>
        att.attachmentIdentifier === attachment.attachmentIdentifier
          ? { ...att, ...attachment }
          : att,
      ),
    );
  };

  const handleAttachmentsChange = (
    newAttachments,
    isAttachmentDeleted = false,
  ) => {
    setAttachments(newAttachments);
    if (isAttachmentDeleted) {
      setAttachmentsMeta((prev) =>
        prev.filter((meta) =>
          newAttachments.some(
            (att) => att.attachmentIdentifier === meta.attachmentIdentifier,
          ),
        ),
      );
    }
  };

  const handleAttachmentsMetaChange = (meta) => {
    setAttachmentsMeta(meta);
  };

  const handleImageUploader = ({ formData, onUploadProgress }) => {
    if (sendImageUploadRequest) {
      return sendImageUploadRequest({ formData, onUploadProgress });
    }
  };

  // Wrapper for resetUploadAttachmentRequest to handle uniqueId parameter
  const handleResetUploadAttachmentRequest = (uniqueId?: number) => {
    if (resetUploadAttachmentRequest) {
      resetUploadAttachmentRequest();
    }
  };

  // Wrapper for resetDeleteAttachmentRequest to handle uniqueId parameter
  const handleResetDeleteAttachmentRequest = (uniqueId?: number) => {
    if (resetDeleteAttachmentRequest) {
      resetDeleteAttachmentRequest();
    }
  };

  const checkWhatsappCharacterLimit = (content: string) => {
    if (selectedStepType === SequenceStepType.WhatsAppMessage) {
      const plainTextLength =
        content?.replace(/<[^>]*>/g, '')?.trim()?.length || 0;
      setIsWhatsappCharacterLimitExceeded(plainTextLength > WHATSAPP_MAX_LIMIT);
    } else {
      // Reset character limit state for non-Message WhatsApp types
      setIsWhatsappCharacterLimitExceeded(false);
    }
  };

  // Check if there are error chips in the content
  const hasErrorChips = (content: string): boolean => {
    if (!content) return false;
    // Check if content contains error-chip-container class
    return content.includes('error-chip-container');
  };

  const handleAddMergeTagInContent = (option) => {
    const { tag } = option;

    let formattedTag = tag;
    const lastPipeIndex = tag.lastIndexOf('|');

    if (lastPipeIndex !== -1) {
      const beforePipe = tag.slice(0, lastPipeIndex + 1);
      const afterPipe = tag.slice(lastPipeIndex + 1);

      formattedTag =
        beforePipe + (isValidHTML(afterPipe) ? afterPipe : nl2br(afterPipe));
    }

    editorRef.current?.insertContent(formattedTag);
  };

  const handleAddVariableTagInContent = (tag) => {
    editorRef.current?.insertContent(tag);
  };

  const dayValidate = (value) => {
    const minRelativeDays = SequenceStepExecutionDay.MinDay;
    return validateRelativeDays(value, minRelativeDays);
  };

  const onKeyDownHandler = (evt) => {
    if (['e', 'E', '+', '-', '.'].includes(evt.key)) {
      evt.preventDefault();
    }
  };

  const handleDueDateChange = (date: Date | null) => {
    setDueDate(date);
    if (date) {
      const today = new Date();
      const todayStart = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
      );
      const selectedDateStart = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
      );
      const diffTime = selectedDateStart.getTime() - todayStart.getTime();
      const diffDays = Math.max(
        1,
        Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1,
      );
      setAbsoluteDays(diffDays);
    } else {
      setAbsoluteDays(1);
    }
  };

  // const onInputChangeHelper = (value) => {
  //   const error = dayValidate(value);

  //   if (!error || value === '') {
  //     setAbsoluteDays(value);
  //   }
  // };

  const isPayloadRequired = () =>
    selectedStepType !== SequenceStepType.LinkedInPostInteraction &&
    selectedStepType !== SequenceStepType.LinkedInViewProfile;

  const onContentChange = (e) => {
    const maxLength =
      contentMaxLength[selectedStepSubType] || contentMaxLength[stepType];

    // Strip chip tags first, then convert to text and remove HTML tags
    // This ensures merge tag chips are counted as their tag format (e.g., {{FirstName}}) not as HTML
    const plainTextLength =
      convertHtmlToText(stripChipTagsFromHtml(e))
        ?.replace(/<[^>]*>/g, '')
        ?.trim()?.length || 0;

    setDirty((preState) => ({ ...preState, content: true }));
    setErrors((preState) => ({
      ...preState,
      content: plainTextLength > maxLength,
    }));

    if (
      selectedStepType === SequenceStepType.LinkedInPostInteraction ||
      selectedStepType === SequenceStepType.LinkedInViewProfile ||
      isCallTask(selectedStepType) ||
      selectedStepType === SequenceStepType.Custom
    ) {
      setTaskNote(e);
      return;
    }

    setStepContentHTML(e);

    // Check WhatsApp character limit
    checkWhatsappCharacterLimit(e);

    // Save WhatsApp Message content separately
    if (selectedStepType === SequenceStepType.WhatsAppMessage) {
      setWhatsappMessageContent(e);
    }
    // Save WhatsApp Voice content separately
    else if (
      selectedStepType === SequenceStepType.WhatsAppVoiceMessage ||
      selectedStepType === SequenceStepType.WhatsAppVoiceCall
    ) {
      setWhatsappVoiceContent(e);
    }

    hideModal();
  };

  const onContentBlur = (isTaskNoteContent = false) => {
    const maxLength =
      contentMaxLength[selectedStepSubType] || contentMaxLength[stepType];

    const contentToValidate = isTaskNoteContent ? taskNote : stepContentHTML;
    // Strip chip tags first, then convert to text for validation
    // This ensures merge tag chips are counted as their tag format (e.g., {{FirstName}}) not as HTML
    const plainTextContent =
      convertHtmlToText(stripChipTagsFromHtml(contentToValidate))
        ?.replace(/<[^>]*>/g, '')
        ?.trim() || '';

    setErrors((preState) => ({
      ...preState,
      content: validate(
        stepType,
        maxLength,
        {
          title: plainTextContent,
        },
        getMinLength(stepType, selectedStepType),
      ),
    }));
  };

  const handleStepType = (type) => {
    const maxLength = contentMaxLength[type] || contentMaxLength[stepType];
    const text = stepContentHTML || taskNote;

    // Strip chip tags first, then convert to text and remove HTML tags
    // This ensures merge tag chips are counted as their tag format (e.g., {{FirstName}}) not as HTML
    const plainTextLength =
      convertHtmlToText(stripChipTagsFromHtml(text))
        ?.replace(/<[^>]*>/g, '')
        ?.trim()?.length || 0;

    setErrors((preState) => ({
      ...preState,
      inMail: false,
      content: plainTextLength > maxLength,
    }));

    // Handle WhatsApp-specific content switching
    if (stepType === StepType.WhatsApp) {
      const currentStepType = getWhatsappInType(type);

      // Reset character limit state when switching WhatsApp types
      setIsWhatsappCharacterLimitExceeded(false);

      // If switching to WhatsApp Message, restore the saved content
      if (currentStepType === SequenceStepType.WhatsAppMessage) {
        setStepContentHTML(whatsappMessageContent);
      }
      // If switching to Voice types, restore the saved voice content
      else if (
        currentStepType === SequenceStepType.WhatsAppVoiceMessage ||
        currentStepType === SequenceStepType.WhatsAppVoiceCall
      ) {
        setStepContentHTML(whatsappVoiceContent);
      }
      // If switching away from WhatsApp Message, save current content
      else if (selectedStepType === SequenceStepType.WhatsAppMessage) {
        setWhatsappMessageContent(stepContentHTML);
        setStepContentHTML('');
      }
      // If switching away from Voice types, save current content
      else if (
        selectedStepType === SequenceStepType.WhatsAppVoiceMessage ||
        selectedStepType === SequenceStepType.WhatsAppVoiceCall
      ) {
        setWhatsappVoiceContent(stepContentHTML);
        setStepContentHTML('');
      }
    }

    setSelectedStepSubType(type);

    if (stepType === StepType.Call) {
      setSelectedStepType(getCallInType(type));
    }
    if (stepType === StepType.LinkedIn) {
      setSelectedStepType(getLinkedInType(type));
    }
    if (stepType === StepType.WhatsApp) {
      setSelectedStepType(getWhatsappInType(type));
    }
    if (stepType === StepType.Task) {
      setSelectedStepType(SequenceStepType.Custom);
    }
  };

  const onInputBlur = () => {
    const maxLength = stepType === StepType.Task ? 100 : 200;

    // Convert HTML to plain text for validation
    const plainTextValue = br2nl(
      convertHtmlToText(stripChipTagsFromHtml(inMailValue)),
    );

    setErrors((preState) => ({
      ...preState,
      inMail: validate(
        stepType,
        maxLength,
        { title: plainTextValue },
        selectedStepType === SequenceStepType.LinkedInInMail ? 2 : 5,
      ),
    }));
  };

  const onInMailSubjectChange = (value: any, e) => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }

    setDirty((preState) => ({ ...preState, inMail: true }));

    // Convert to plain text only for validation
    const stripValue = convertHtmlToText(stripChipTagsFromHtml(value));
    setErrors((preState) => ({
      ...preState,
      inMail: br2nl(stripValue)?.length > subjectInputMaxLength(stepType),
    }));

    // Store the HTML value, not the plain text
    setInMailValue(value);
  };

  //* API Call Functions */
  const getAPIPayload = () => {
    const payload: {
      content?: string;
      subject?: string;
      preheader?: string;
      message?: string;
      title?: string;
    } = {};

    // Map connectionNote to content for task creation API
    if (isPayloadRequired()) {
      if (
        !isWhatsappTask(selectedStepType) &&
        selectedStepType !== SequenceStepType.LinkedInInMail &&
        selectedStepType !== SequenceStepType.LinkedInMessage &&
        selectedStepType !== SequenceStepType.Custom &&
        !isCallTask(selectedStepType)
      ) {
        // Map connectionNote to content
        payload.content = stripChipTagsFromHtml(stepContentHTML?.trim());
      }

      if (
        isWhatsappTask(selectedStepType) ||
        selectedStepType === SequenceStepType.LinkedInInMail ||
        selectedStepType === SequenceStepType.LinkedInMessage
      ) {
        payload.message = stripChipTagsFromHtml(stepContentHTML?.trim());
      }
    }

    // Handle subject for LinkedIn InMail
    if (selectedStepType === SequenceStepType.LinkedInInMail) {
      payload.subject = convertHtmlToText(
        stripChipTagsFromHtml(inMailValue),
      )?.trim();
    }

    // Handle title for Custom tasks
    if (
      selectedStepType === SequenceStepType.Custom &&
      inMailValue?.length > 0
    ) {
      payload.title = convertHtmlToText(
        stripChipTagsFromHtml(inMailValue),
      )?.trim();
    }

    return payload;
  };

  const resetForm = () => {
    setAbsoluteDays(1);
    setSelectedStepType(initialStepType);
    setSelectedStepSubType(getInitialSubType(initialStepType));
    setStepType(defaultStepType);
    setStepContentHTML('');
    setTaskNote('');
    setWhatsappMessageContent('');
    setWhatsappVoiceContent('');
    setSelectedPriority(SequenceStepPriorityValue.Normal);
    setSelectedAssignee(userId);
    setInMailValue('');
    setAttachments([]);
    setAttachmentsMeta([]);
    setIsWhatsappCharacterLimitExceeded(false);
    // setCopiedField(null);
    setDueDate(null);
    setIsCompleted(false);
    setIsCallOutcomeModalVisible(false);
    setCallOutcome(null);
    setErrors({
      buttonName: false,
      buttonLink: false,
      inMail: false,
      content: false,
    });
    setDirty({
      buttonName: false,
      buttonLink: false,
      inMail: false,
      content: false,
      inMailSubject: false,
      customTitle: false,
    });
  };

  // Compute plain text value for validation
  const plainTextInMailValue = convertHtmlToText(
    stripChipTagsFromHtml(inMailValue),
  );

  const submitTask = () => {
    // Calculate absoluteDays from dueDate if provided, otherwise use the current absoluteDays
    // let calculatedAbsoluteDays = absoluteDays;
    // if (dueDate) {
    //   const today = new Date();
    //   const todayStart = new Date(
    //     today.getFullYear(),
    //     today.getMonth(),
    //     today.getDate(),
    //   );
    //   const selectedDateStart = new Date(
    //     dueDate.getFullYear(),
    //     dueDate.getMonth(),
    //     dueDate.getDate(),
    //   );
    //   const diffTime = selectedDateStart.getTime() - todayStart.getTime();
    //   calculatedAbsoluteDays = Math.max(
    //     1,
    //     Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1,
    //   );
    // }

    // Create payload for task creation API (flat structure, not variants)
    const formData = {
      prospectId: selectedProspectId,
      type: selectedStepType,
      // absoluteDays: calculatedAbsoluteDays,
      priority: selectedPriority,
      assigneeId: selectedAssignee,
      taskNote: stripChipTagsFromHtml(taskNote),
      payload: getAPIPayload(),
      ...(isCompleted && { taskAction: 0 }),
      ...(dueDate && {
        dueDate: combineDateWithCurrentTime(dueDate).toString(),
      }),
      ...(attachments?.length > 0 && {
        attachmentIds: attachments
          ?.filter((att) => att?.attachmentId != null)
          ?.map((att) => att?.attachmentId),
      }),
      ...(isCompleted &&
        isCallTask(selectedStepType) &&
        callOutcome?.key && {
          callOutcome: callOutcome.key,
        }),
    };

    onSubmit?.(formData);
    resetForm();
  };

  const handleSubmit = () => {
    if (
      !isFormValid(errors) ||
      (stepType === StepType.Task && plainTextInMailValue?.length === 0)
    ) {
      return;
    }

    // Check if it's a demo account and show restriction modal if needed
    // if (getIsDemoAccount()) {
    //   if (setShowGlobalRestrictionModal) {
    //     setShowGlobalRestrictionModal(selectedStepType);
    //   }
    //   return;
    // }

    // If "Mark as Completed" is checked and it's a call task, ensure call outcome is selected
    if (isCompleted && isCallTask(selectedStepType)) {
      // If call outcome is not selected, show the modal (edge case - should already be open)
      if (!callOutcome) {
        setIsCallOutcomeModalVisible(true);
        return;
      }
    }

    // Proceed with submission
    submitTask();
  };

  const handleCallOutcomeConfirm = () => {
    if (!callOutcome) {
      return;
    }
    // Just close the modal and keep the call outcome selected
    // The actual API call will happen when "Add Task" button is clicked
    setIsCallOutcomeModalVisible(false);
  };

  const handleCallOutcomeCancel = () => {
    // When user clicks "No", uncheck the checkbox and clear call outcome
    setIsCallOutcomeModalVisible(false);
    setCallOutcome(null);
    setIsCompleted(false);
  };

  const handleCancel = () => {
    resetForm();
    onCancel?.();
  };

  const handleCompletedChange = (checked: boolean) => {
    setIsCompleted(checked);

    // If checking the box and it's a call task, open the modal
    if (
      checked &&
      (stepType === StepType.Call || isCallTask(selectedStepType))
    ) {
      setIsCallOutcomeModalVisible(true);
    } else if (!checked) {
      // If unchecking, clear the call outcome
      setCallOutcome(null);
      setIsCallOutcomeModalVisible(false);
    }
  };

  //* useEffect */
  // Fetch fields on mount if not provided and not already in store
  useEffect(() => {
    // Only fetch if fields are not provided as prop AND not already in store
    if (
      (!fieldsProp || fieldsProp.length === 0) &&
      (!fieldsFromStore || fieldsFromStore.length === 0)
    ) {
      dispatch(getFieldsRequest());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run once on mount

  // Update stepType when initialStepType changes
  useEffect(() => {
    if (initialStepType) {
      const calculatedStepType = getStepType(initialStepType);
      setStepType(calculatedStepType);
    }
  }, [initialStepType]);

  // Reset form when stepType changes
  useEffect(() => {
    // Handle Task and Email types that don't have sub-types
    if (stepType === StepType.Task) {
      setSelectedStepType(SequenceStepType.Custom);
      setSelectedStepSubType('');
    } else if (stepType === StepType.Email) {
      setSelectedStepType(SequenceStepType.Email);
      setSelectedStepSubType('');
    } else {
      // For types with sub-types (WhatsApp, LinkedIn, Call)
      // If initialStepType matches the current stepType, use its sub-type
      // Otherwise, use the default sub-type for the stepType
      const initialSubType = getInitialSubType(initialStepType);
      const calculatedStepTypeFromInitial = initialStepType
        ? getStepType(initialStepType)
        : null;
      const defaultSubType = getDefaultSubTypeForStepType(stepType);

      // Use initial sub-type if it matches the current stepType, otherwise use default
      const subTypeToUse =
        calculatedStepTypeFromInitial === stepType && initialSubType
          ? initialSubType
          : defaultSubType || initialSubType;

      setSelectedStepSubType(subTypeToUse);
      handleStepType(subTypeToUse);
    }

    setInMailValue('');
    setTaskNote('');
    setStepContentHTML('');
    setWhatsappMessageContent('');
    setWhatsappVoiceContent('');
    setIsWhatsappCharacterLimitExceeded(false);
    setErrors({
      buttonName: false,
      buttonLink: false,
      inMail: false,
      content: false,
    });
  }, [stepType]);

  useEffect(() => {
    if (
      selectedStepType === SequenceStepType.WhatsAppMessage &&
      stepContentHTML
    ) {
      checkWhatsappCharacterLimit(stepContentHTML);
    }
  }, [selectedStepType, stepContentHTML]);

  // Set default assignee to first item in taskAssigneeList when available
  useEffect(() => {
    if (
      Array.isArray(taskAssigneeList) &&
      taskAssigneeList.length > 0 &&
      taskAssigneeList[0]?.id
    ) {
      setSelectedAssignee(taskAssigneeList[0].id);
    }
  }, [taskAssigneeList]);

  //* class variable */
  const getChannelClasses = (key) =>
    classnames([
      'channel pointer',
      {
        'channel-disable': false,
      },
    ]);

  //* Render Functions */
  const renderHeader = () => (
    <div className="d-flex align-items-center justify-content-center">
      <div className="channels d-flex justify-content-center">
        {getChannels(stepType).map(({ icon, key }, idx) => (
          <div
            key={idx}
            className={getChannelClasses(key)}
            style={{
              backgroundColor: key === stepType && stepBgColor[key],
              color: key === stepType && '#fff',
              outline: key === stepType && 'none',
            }}
            {...accessibleOnClick(() => {
              setStepType(key);
              // The useEffect will handle setting the correct sub-type and selectedStepType
            })}
          >
            {icon}
          </div>
        ))}
      </div>
    </div>
  );

  const renderMergeTagSelection = (isContentArea = true) => (
    <OverlayMergeTags
      options={mergeTagOptions}
      onChange={(option) => {
        const { tag } = option;
        if (isContentArea && editorRef.current) {
          // Use insertChipForMergeTag to create chip HTML directly
          const uuid = uuidv4();
          let formattedTag = tag;
          const lastPipeIndex = tag.lastIndexOf('|');

          if (lastPipeIndex !== -1) {
            const beforePipe = tag.slice(0, lastPipeIndex + 1);
            const afterPipe = tag.slice(lastPipeIndex + 1);

            formattedTag =
              beforePipe +
              (isValidHTML(afterPipe) ? afterPipe : nl2br(afterPipe));
          }

          // Find the tag option to get fieldType
          const tagOption = mergeTagOptions.find(
            (opt) => opt.tag === tag || opt.value === tag,
          );

          // Insert chip HTML directly instead of raw merge tag
          editorRef.current?.insertContent(
            insertChipForMergeTag(
              formattedTag,
              uuid,
              false,
              true,
              tagOption?.fieldType,
            ),
          );
          // Move caret to after the inserted chip
          setCaretAfterChip(editorRef.current, uuid);
          return;
        }

        if (!isContentArea && inMailEditorRef.current) {
          const uuid = uuidv4();
          const chipHtml = insertChipForMergeTag(
            tag,
            uuid,
            false,
            true,
            option?.fieldType,
          );

          inMailEditorRef?.current?.insertContent(chipHtml);
          // Move caret to after the inserted chip
          setCaretAfterChip(inMailEditorRef.current, uuid);
          return;
        }

        // Fallback to plain text insertion for non-editor inputs
        insertTextAtCursor(
          isContentArea ? contentRef?.current : inMailRef.current,
          option?.tag,
        );
      }}
      placement={Placement.BottomEnd}
      searchPlaceholder="Search Tags"
      className="merge-tags-dropdown"
      showAiGeneratedIcon
    >
      <div
        onMouseDown={(evt) => {
          evt.preventDefault(); // Avoids loosing focus from the editable area
        }}
        className="gray-16 task-merge-tag bs-border-radius-50 pointer"
      >
        <Braces2 width={16} height={16} className="pointer" />
      </div>
    </OverlayMergeTags>
  );

  // Check if we should use Editor component for WhatsApp messages
  const shouldUseEditor = selectedStepType === SequenceStepType.WhatsAppMessage;

  const DatePickerInput = React.forwardRef<
    HTMLInputElement,
    React.HTMLProps<HTMLInputElement> & {
      onClear?: () => void;
    }
  >(({ value, onClick, onChange, onClear }, ref) => (
    <div className="bs-input date-picker-container">
      <Calendar />
      <input
        placeholder="Select Date"
        onClick={onClick}
        className="input bs-input"
        style={{ textIndent: 0 }}
        onChange={onChange}
        value={value ? value.toString() : ''}
        ref={ref}
        readOnly // important to avoid manual typing issues
      />

      <div className="d-flex align-items-center">
        {onClear && value && (
          <Icon
            className="cal-icon mr-1 sh-close close-icon"
            identifier="close"
            onClick={(e) => {
              e.stopPropagation();
              onClear?.();
            }}
          />
        )}
      </div>
    </div>
  ));

  const getEditorClassName = () => {
    const height = getEditorHeight(stepType, selectedStepType);
    return `sequence-step-editor margin-12 sequence-step-editor-height-${height
      .replace('px', '')
      .replace('rem', 'rem')}`;
  };

  return (
    <>
      <div className="add-task-form-container">
        {renderHeader()}

        {/* Select Task Sub Type */}
        {isSubTypeSectionVisible(stepType) && (
          <div className="mt-4">
            <StepTaskType
              label={getSubTypeSectionLabel(stepType)}
              stepType={stepType}
              selectedTaskType={selectedStepSubType}
              onChange={(type) => handleStepType(type)}
              mode={SequenceStepAction.CreateStep}
            />
          </div>
        )}

        <div className="d-flex gap-16 flex-column">
          <div className="w-100 mt-3 pr-3 pl-3 content-body">
            {/* InMail Subject */}
            {(selectedStepType === SequenceStepType.LinkedInInMail ||
              selectedStepType === SequenceStepType.Custom) && (
              <div className="w-100 mb-3 task-form-header-container">
                <div className="d-flex align-items-center justify-content-between task-form-header">
                  <div className="d-flex">
                    <span className="semibold-1 gray-txt-15">
                      {selectedStepType === SequenceStepType.Custom
                        ? 'Task Title'
                        : 'InMail Subject'}
                    </span>
                    <OverlayTooltip
                      text={
                        selectedStepType === SequenceStepType.Custom
                          ? 'Task title is mandatory'
                          : 'Write personalized InMail subject line'
                      }
                      className="tooltip-mdd"
                    >
                      <InfoCircle
                        width={18}
                        height={18}
                        className="gray-txt-11 ml-2"
                      />
                    </OverlayTooltip>
                  </div>
                  {selectedStepType === SequenceStepType.LinkedInInMail &&
                    renderMergeTagSelection(false)}
                </div>
                <SingleEditorInput
                  key={selectedStepType}
                  inputValue={inMailValue}
                  inputRef={inMailRef}
                  onInputChange={onInMailSubjectChange}
                  placeholder={
                    selectedStepType === SequenceStepType.LinkedInInMail
                      ? 'Add a subject line here'
                      : 'Add a task title'
                  }
                  onInputBlur={onInputBlur}
                  inputClassName="task-subject-input"
                  enableMergeTag={false}
                  enableSpintax={false}
                  enableEmoji={false}
                  showTitle=""
                  mergeTagOptions={mergeTagOptions}
                  showInlineCount={true}
                  maxInputCount={
                    selectedStepType === SequenceStepType.LinkedInInMail
                      ? 200
                      : 100
                  }
                  getEditorInstance={(editor) => {
                    inMailEditorRef.current = editor;
                  }}
                  error={errors?.inMail}
                />
                {errors.inMail && (
                  <span className="regular-1 red-txt-12 line-height-18 mt-1">
                    {getErrorString(
                      errors.inMail,
                      plainTextInMailValue,
                      subjectInputMaxLength(stepType),
                      selectedStepType === SequenceStepType.LinkedInInMail
                        ? 2
                        : 5,
                    )}
                  </span>
                )}
              </div>
            )}

            {/* Add Task Message / Description */}
            <div className="d-flex align-items-center justify-content-between w-100">
              <div>
                <span className="semibold-1 gray-txt-15">
                  {getStepContentSectionLabel(selectedStepType)}
                </span>
                <OverlayTooltip
                  text={getSequenceTypeTooltipText(selectedStepType)}
                  className="tooltip-mdd"
                >
                  <InfoCircle
                    width={18}
                    height={18}
                    className="gray-txt-11 ml-2"
                  />
                </OverlayTooltip>
              </div>
              {!shouldUseEditor && renderMergeTagSelection()}
            </div>

            {/* {shouldUseEditor ? (
            <Editor
              value={stepContentHTML}
              onEditorChange={onContentChange}
              error={errors.content}
              className="whatsapp-editor"
              showMinimalToolbar={true}
              showAddAttachments={true}
              showMergeAndVariableTags={true}
              mergeTags={mergeTagOptions}
              attachments={attachments}
              onAttachmentStatusChange={handleAttachmentStatusChange}
              onAttachmentsChange={handleAttachmentsChange}
              onAttachmentsMetaChange={handleAttachmentsMetaChange}
              sendAttachmentUploadRequest={(payload) => {
                console.log('Attachment upload requested:', payload);
                // TODO: Implement attachment upload
              }}
              uploadAttachmentRequestStatus={null}
              uploadAttachmentRequestError={null}
              uploadedAttachment={null}
              resetUploadAttachmentRequest={() => {
                // No-op for now
              }}
              sendDeleteAttachmentRequest={(payload) => {
                console.log('Attachment delete requested:', payload);
                // TODO: Implement attachment delete
              }}
              deleteAttachmentRequestStatus={null}
              deleteAttachmentRequestError={null}
              deletedAttachmentId={null}
              resetDeleteAttachmentRequest={() => {
                // No-op for now
              }}
              imageUploader={handleImageUploader}
              addMergeTagInContent={handleAddMergeTagInContent}
              addVariableTagInContent={handleAddVariableTagInContent}
              getEditorInstance={(editor) => {
                editorRef.current = editor;
              }}
              uniqueId={uniqueId}
              attachmentsClassname="whatsapp-attachments"
              maxInputCount={WHATSAPP_MAX_LIMIT}
              showCount
              placeholder="Enter the message you want to send to prospects."
              sequenceStepVariantId={null}
              isTemplateEditorModal={false}
            />
          ) : (
            <StepContentArea
              ref={contentRef}
              stepContentHTML={
                getIsTaskNoteContent(selectedStepType)
                  ? taskNote
                  : stepContentHTML
              }
              isContentError={errors.content}
              placeholder={getPlaceHolderText(selectedStepSubType, stepType)}
              onChange={(value) => onContentChange(value)}
              onBlur={onContentBlur}
              maxLength={
                contentMaxLength[selectedStepSubType] ||
                contentMaxLength[stepType]
              }
              minLength={getMinLength(stepType, selectedStepType)}
              isExpandOptionVisible={getIsExpandOptionVisible(
                stepType,
                selectedStepType,
              )}
              onExpandContentArea={showModal}
              size={getContentAreaSize(stepType, selectedStepType)}
            />
          )} */}
            <Editor
              key={`editor-${
                shouldUseEditor ? 'whatsapp' : 'general'
              }-${selectedStepSubType}-${stepType}`}
              value={
                shouldUseEditor
                  ? stepContentHTML
                  : getIsTaskNoteContent(selectedStepType)
                  ? taskNote?.trim()
                  : stepContentHTML?.trim()
              }
              onEditorChange={onContentChange}
              error={errors.content}
              className={getEditorClassName()}
              showMinimalToolbar={shouldUseEditor}
              showAddAttachments={shouldUseEditor}
              showMergeAndVariableTags={true}
              mergeTags={mergeTagOptions}
              addMergeTagInContent={handleAddMergeTagInContent}
              addVariableTagInContent={handleAddVariableTagInContent}
              getEditorInstance={(editor) => {
                editorRef.current = editor;
              }}
              maxInputCount={
                shouldUseEditor
                  ? WHATSAPP_MAX_LIMIT
                  : contentMaxLength[selectedStepSubType] ||
                    contentMaxLength[stepType]
              }
              showCount
              placeholder={
                shouldUseEditor
                  ? 'Enter the message you want to send to prospects.'
                  : getPlaceHolderText(selectedStepSubType, stepType)
              }
              isTemplateEditorModal={false}
              hideHeader={!shouldUseEditor}
              disableSpinTagConversion={true}
              {...(shouldUseEditor && {
                attachments,
                onAttachmentStatusChange: handleAttachmentStatusChange,
                onAttachmentsChange: handleAttachmentsChange,
                onAttachmentsMetaChange: handleAttachmentsMetaChange,
                sendAttachmentUploadRequest: sendUploadAttachmentRequest,
                uploadAttachmentRequestStatus,
                uploadAttachmentRequestError,
                uploadedAttachment:
                  uploadedAttachment &&
                  typeof uploadedAttachment === 'object' &&
                  !Array.isArray(uploadedAttachment)
                    ? uploadedAttachment
                    : undefined,
                resetUploadAttachmentRequest: handleResetUploadAttachmentRequest,
                sendDeleteAttachmentRequest,
                deleteAttachmentRequestStatus,
                deleteAttachmentRequestError,
                deletedAttachmentId,
                resetDeleteAttachmentRequest: handleResetDeleteAttachmentRequest,
                imageUploader: handleImageUploader,
                uniqueId,
                attachmentsClassname: 'whatsapp-attachments',
              })}
            />

            {/* Add Task Note */}
            {selectedStepType !== SequenceStepType.LinkedInPostInteraction &&
              selectedStepType !== SequenceStepType.LinkedInViewProfile &&
              selectedStepType !== SequenceStepType.Custom &&
              !isCallTask(selectedStepType) && (
                <TaskNote
                  taskNote={taskNote}
                  mergeTagOptions={mergeTagOptions}
                  onTaskNoteSave={(note: string) => setTaskNote(note)}
                  onContentBlur={() => onContentBlur(true)}
                />
              )}
          </div>

          <div className="pr-4 pl-4 d-flex flex-column gap-16 prospect-task-assigne-container">
            <div className="d-flex justify-content-between flex-grow-1 gap-12 prospect-task-assignee">
              <div className="d-flex flex-column gap-12 task-due-date">
                <span className="semibold-1 gray-txt-15">Due Date</span>
                <DatePicker
                  selected={dueDate}
                  onChange={(date) => handleDueDateChange(date)}
                  minDate={new Date()}
                  dateFormat="MMM dd, yyyy"
                  value={dueDate}
                  customInput={
                    <DatePickerInput onClear={() => setDueDate(null)} />
                  }
                  wrapperClassName="due-date-picker-wrapper"
                />
              </div>
              <TaskAssignee
                taskAssigneeList={
                  Array.isArray(taskAssigneeList) ? taskAssigneeList : []
                }
                selectedAssignee={selectedAssignee}
                onAssigneeChange={(option) =>
                  setSelectedAssignee(option?.value)
                }
              />
            </div>
            <TaskPriority
              selectedPriority={selectedPriority}
              onPriorityChange={(priority) => setSelectedPriority(priority)}
            />

            {/* Day Input */}
            {/* <div className="day-input-spinner d-flex align-items-center mt-3">
            <label
              className="regular-2 font-medium popover-arrow-color-txt d-flex align-items-center m-0"
              htmlFor="days"
            >
              {label}
              <InputNumber
                id="days"
                name="relativeDays"
                className="day-number m-0 ml-2 mr-2"
                min={SequenceStepExecutionDay.MinDay}
                max={SequenceStepExecutionDay.MaxDay}
                value={absoluteDays}
                onChange={onInputChangeHelper}
                onKeyDown={onKeyDownHandler}
              />
            </label>
          </div> */}

            {/* Action Buttons */}
            <div className="d-flex justify-content-between align-items-center gap-8 mt-3 add-task-form-actions">
              <div className="d-flex align-items-center gap-8">
                <Checkbox
                  key={`isCompleted-${isCompleted}`}
                  id="isCompleted"
                  checked={isCompleted}
                  onChange={(e) => handleCompletedChange(e.target.checked)}
                />
                <span className="mark-as-completed">Mark as Completed</span>
              </div>
              <div className="d-flex gap-8">
                <Button className="cancel-btn" onClick={handleCancel}>
                  Cancel
                </Button>

                <Button
                  onClick={handleSubmit}
                  disabled={
                    isSubmitLoading ||
                    !isFormValid(errors) ||
                    (stepType === StepType.Task &&
                      plainTextInMailValue?.length === 0) ||
                    isSubmitDisabled(selectedStepType, {
                      content: stepContentHTML,
                      subject: plainTextInMailValue,
                    }) ||
                    isWhatsappCharacterLimitExceeded ||
                    hasErrorChips(stepContentHTML || taskNote)
                  }
                  isLoading={isSubmitLoading}
                >
                  Add Task
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Content Area Modal */}
      {isAddTaskModalVisible && (
        <TaskNoteModal
          show={isAddTaskModalVisible}
          title={getTaskNoteModalTitle(selectedStepType)}
          maxLength={getTaskNoteModalMaxLength(selectedStepType)}
          onClose={hideModal}
          isExpandOptionVisible={true}
          mergeTagOptions={mergeTagOptions}
          contentAreaPlaceholder={getPlaceHolderText(
            selectedStepSubType,
            stepType,
          )}
          taskNote={
            getIsTaskNoteContent(selectedStepType) ? taskNote : stepContentHTML
          }
          onSubmit={(value: string) => onContentChange(value)}
        />
      )}

      {/* Call Outcome Modal */}
      {isCallOutcomeModalVisible &&
        (stepType === StepType.Call || isCallTask(selectedStepType)) && (
          <ConfirmationModalV3
            show={isCallOutcomeModalVisible}
            onSubmit={handleCallOutcomeConfirm}
            onClose={handleCallOutcomeCancel}
            showCloseIcon={false}
            hideTitleIcon={true}
            icon={
              <CircleCheck width={24} height={24} className="orange-txt-14" />
            }
            title={getTaskActionTitle(TaskAction.ExecuteTask, 1)}
            cancelButtonText="No"
            submitButtonText="Yes"
            content={
              <>
                <div className="d-flex flex-column gap-16">
                  <div className="regular-2 popover-arrow-color-txt line-height-24">
                    <span>You're about to mark task as complete.</span>
                  </div>
                  <span className="regular-2 popover-arrow-color-txt complete-task-description line-height-24">
                    {getCallTaskDesc(1)}
                  </span>
                </div>
                <div className="mt-3">
                  <Select<{ key: string; label: string }>
                    options={getCallOutcomeOptions}
                    placeholder="Select call task outcome"
                    selectedOptionKey={callOutcome?.key}
                    onChange={([option]) => setCallOutcome(option)}
                    optionRenderer={(option) => <span>{option?.label}</span>}
                    selectedOptionRenderer={([option]) => (
                      <span>{option?.label}</span>
                    )}
                  />
                </div>
              </>
            }
            isSubmitLoading={isSubmitLoading}
            isSubmitDisabled={!callOutcome || isSubmitLoading}
            className={`task-confirmation-modal ${getConfirmationModalClass(
              TaskAction.ExecuteTask,
              selectedStepType,
              [],
            )}`}
          />
        )}
    </>
  );
};

export default AddTaskForm;
